import { ModalDialog } from 'commons/components';
import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocProgressSpinner } from 'commons/components/components-wrapper/poc-progress-spinner.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n';
import { CustomAlarmListItem } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';
import { getCustomAlarmDeletionTexts } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-deletion-confirmation-modal/custom-alarm-deletion-confirmation-modal.business';
import { CustomAlarmDeletionConfirmationModalHeaderComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-deletion-confirmation-modal/custom-alarm-deletion-confirmation-modal-header.component';
import React, { useState } from 'react';
import { PopupProps } from 'react-popup-manager';
import { CustomAlarmModalContent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.style';

export interface CustomAlarmDeletionConfirmationModalComponentProps extends PopupProps {
    alarmDefinitions: CustomAlarmListItem[];
    onConfirm: () => Promise<void>;
}

export const CustomAlarmDeletionConfirmationModalComponent: React.FC<
    CustomAlarmDeletionConfirmationModalComponentProps
> = (props) => {
    const { alarmDefinitions, onClose, isOpen, onConfirm } = props;
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const texts = getCustomAlarmDeletionTexts(alarmDefinitions);

    const handleConfirm = async () => {
        setIsLoading(true);
        try {
            await onConfirm();
            onClose?.();
        } catch {
            // notification already shown by the deleter; keep the modal open for retry
        } finally {
            setIsLoading(false);
        }
    };

    const footerOptions = (
        <PocButton
            id="custom-alarm-delete-confirmation-modal-button"
            key="custom-alarm-delete-confirmation-modal-button"
            data-testid="custom-alarm-delete-confirmation-modal-button"
            onClick={handleConfirm}
            disabled={isLoading}
        >
            {isLoading ? (
                <PocProgressSpinner size="xSmall" style={{ display: 'block' }} />
            ) : (
                t('settings.devices.custom-alarms.delete.modal.delete')
            )}
        </PocButton>
    );

    return (
        <ModalDialog
            onClose={onClose}
            isOpen={isOpen}
            title={<CustomAlarmDeletionConfirmationModalHeaderComponent alarmDefinitions={alarmDefinitions} />}
            footerOptions={footerOptions}
        >
            <CustomAlarmModalContent>
                <PocTypography variant="body1">{t(texts.bodyText)}</PocTypography>
            </CustomAlarmModalContent>
        </ModalDialog>
    );
};
